"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tableHelpers = _interopRequireDefault(require("../../helpers/tableHelpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionTable = function SectionTableComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData,
      linkedContent = _ref.linkedContent;
  var linkedTableData = (0, _tableHelpers["default"])(sliceData, linkedContent);

  if (!linkedTableData) {
    return null;
  }

  var sectionTableId = sliceData.primary.section_table_id;
  var tableHeader = linkedTableData.contentData.body.slice(0, 1)[0].items;
  var tableBody = linkedTableData.contentData.body.slice(1);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__table-wrapper",
    id: sectionTableId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "content-page__table"
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    className: "content-page__table-head"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "content-page__table-row--head"
  }, tableHeader.map(function (tableCell, idx) {
    var key = "table-head-cell-".concat(idx);
    return /*#__PURE__*/_react["default"].createElement("th", {
      className: "content-page__table-cell--head",
      key: key
    }, dataClient.textToMarkdown(tableCell.table_cell_content));
  }))), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "content-page__table-body"
  }, tableBody.map(function (tableRow, idx) {
    var rowKey = "table-row-".concat(idx);
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: "content-page__table-row",
      key: rowKey
    }, tableRow.items.map(function (tableCell, idx) {
      var cellKey = "cell-".concat(rowKey, "-").concat(idx);
      return /*#__PURE__*/_react["default"].createElement("td", {
        className: "content-page__table-cell",
        key: cellKey
      }, dataClient.renderFullMarkup(tableCell.table_cell_content));
    }));
  })))));
};
/* eslint-disable camelcase */


SectionTable.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      linked_table: _propTypes["default"].shape({
        id: _propTypes["default"].string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  dataClient: _propTypes["default"].shape({}).isRequired,
  linkedContent: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].string.isRequired,
    contentData: _propTypes["default"].shape({}).isRequired
  })).isRequired
};
var _default = SectionTable;
exports["default"] = _default;